import { render, staticRenderFns } from "./PreparingSuccess.vue?vue&type=template&id=22e93a91&"
import script from "./PreparingSuccess.vue?vue&type=script&lang=js&"
export * from "./PreparingSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports